import { DateRange } from 'react-day-picker';

export interface SYS5010_R01Dto {
	userId: string;
	userNm: string;
	deviceType: string;
	loginDt: string;
	ipAddr: string;
	logoutDt: string;
	remark: string;

	valueIndex?: number;
	/** GridContextWrapper 스타일 제어용 필드 */
	inserted?: boolean;
}

export interface SYS5010_R01Filter {
	dateRange: DateRange | undefined;
	userId: string;
	userNm: string;
}

export const defaultSYS5010_R01Dto: SYS5010_R01Dto = {
	userId: '',
	userNm: '',
	deviceType: '',
	loginDt: '',
	ipAddr: '',
	logoutDt: '',
	remark: '',
	valueIndex: 0,
};

export const defaultSYS5010_R01Filter: SYS5010_R01Filter = {
	dateRange: {
		from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
		to: new Date(),
	},
	userId: '',
	userNm: '',
};
